import { getImg } from 'src/services/AssetApi';
import { convertStringToIdName } from 'src/utils/string-parsers';
import TypeChecker from 'src/utils/type-checker';

// Using for validation
export const conditionalRequired = (schema, msg, isRequired = true) => {
  return schema
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value; // force empty string to null
    })
    .when([], {
      is: () => isRequired,
      then: (s) => s.required(msg),
      otherwise: (s) => s.notRequired().nullable(),
    });
};

  // const schema = Yup.object({
  //   age: conditionalRequired(Yup.number(), 'Tuổi là bắt buộc'),
  //   name: conditionalRequired(Yup.string().nullable(), 'Tên là bắt buộc'),
  //   tags: conditionalRequired(Yup.array().of(Yup.string()), 'Chọn ít nhất một'),
    
  //   gender: conditionalRequired(
  //     Yup.object()
  //       // Optional
  //       .shape({
  //         code: Yup.string().required('Giới tính không hợp lệ'),
  //         label: Yup.string().required(),
  //       })
  //       // EOF
  //       .nullable(),
  //     'Giới tính là bắt buộc'
  //   ),
  // });

// Get and check id exist in object
export const getDefaultItemId = (item) => {
  if (item && typeof item === 'object' && 'id' in item) {
    const id = Number(item.id);
    return Number.isFinite(id) ? id : 0;
  }
  return 0;
};

// Set single image default to formik from string
export const setDefaultImageFromStr = (formik, str) => {
  const obj = convertStringToIdName(str);
  setDefaultImageFromObj(formik, obj);
};

// Set single image default to formik from object
export const setDefaultImageFromObj = (formik, object) => {
  if(TypeChecker.isObject(object)){
    // Create a copy of item.asset and override the name property
    const assetCopy = { ...object, name: getImg(object.name) };
    // Set Formik field
    formik.setFieldValue('defaultImg', assetCopy);   
    formik.setFieldValue('image', object.name);
  }else{
    formik.setFieldValue('defaultImg', {});   
    formik.setFieldValue('image', null);
  }
};

// Set default plate from string
export const setDefaultPlateFromStr = (formik, str) => {
  const obj = convertStringToIdName(str);
  setDefaultPlateFromObj(formik, obj);
}

// Set default plate from object
export const setDefaultPlateFromObj = (formik, object) => {
  if(TypeChecker.isObject(object)){
    formik.setFieldValue('myCarId', object.id);
    formik.setFieldValue('plateField', null);
  }
}
